/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import { graphql, useStaticQuery } from 'gatsby'
import { nl2br } from "../../../../utils/string-helpers"
import * as s from './css/hero-image.module.css';

const Content = ({project}) => {
  return (
    <>
      <div className={s.bgGradient} />
      <div className={`container ${s.titleContainer}`}>
        <div className={s.title} dangerouslySetInnerHTML={{ __html: nl2br(project.heroTitle) }} />
      </div>
    </>
  );
}

const HeroImage = ({ project }) => {

  const dataImages = useStaticQuery(graphql`
{
  allFile {
    edges {
      node {
        publicURL
        base
      }
    }
  }
}
`)

  const edgeDesktop = dataImages.allFile.edges.find(e => e.node.base.indexOf(`hero_desktop_${project.__influencerCode}.`) === 0);
  const edgeMobile = dataImages.allFile.edges.find(e => e.node.base.indexOf(`hero_mobile_${project.__influencerCode}.`) === 0);

  return (
    <div className={`full-container ${s.container}`}>
      <div className={`${s.image} hidden desktop:block`} style={{ backgroundImage: `url(${edgeDesktop.node.publicURL})` }}>
        <Content project={project} />
      </div>
      <div className={`${s.image} block desktop:hidden`} style={{ backgroundImage: `url(${edgeMobile.node.publicURL})` }}>
        <Content project={project} />
      </div>
    </div>
  );
}

export default HeroImage
